var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.backlineComb,
          expression: "backlineComb"
        }
      ]
    },
    [
      _c("div", { staticClass: "sm-function-module-content" }, [
        _c("div", { staticClass: "boxchild" }, [
          _c(
            "button",
            {
              staticClass: "tbtn tbn1",
              attrs: { type: "button" },
              on: { click: _vm.analysis }
            },
            [_vm._v(" 分析 ")]
          ),
          _c(
            "button",
            {
              staticClass: "tbtn",
              attrs: { type: "button" },
              on: { click: _vm.clear }
            },
            [_vm._v("清除")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }